export default __webpack_public_path__ + "static/media/item3.62c1d565.svg";